import JobRemoveModalWithTracking from "../../../containers/JobRemoveModalWithTracking";
import useJobRemoveModal from "../../../hooks/useJobRemoveModal";
import type { CrmEnrichmentJob } from "../../../types/types";
import useSfEnrichmentJobRemoveMutation from "../query/mutations/useSfEnrichmentJobRemoveMutation";

type SfEnrichmentJobRemoveModalContainerProps = {
    job: CrmEnrichmentJob;
    onSuccess?: VoidFunction;
    onClose?: VoidFunction;
};

const SfJobRemoveModalContainer = ({ job, onSuccess, onClose }: SfEnrichmentJobRemoveModalContainerProps) => {
    const { isOpen, closeModal } = useJobRemoveModal();

    const handleCloseModal = () => {
        closeModal();
        onClose?.();
    };

    const { mutate: mutateRemove, isPending: isLoadingRemove } = useSfEnrichmentJobRemoveMutation();

    const handleRemoveJob = (): void => {
        mutateRemove(job, {
            onSuccess: () => {
                handleCloseModal();
                onSuccess?.();
            },
        });
    };

    return (
        <JobRemoveModalWithTracking
            job={job}
            crmProvider="salesforce"
            isOpened={isOpen}
            isSubmitLoading={isLoadingRemove}
            onClose={handleCloseModal}
            onRemoveJob={handleRemoveJob}
        />
    );
};

export default SfJobRemoveModalContainer;
